export default __webpack_public_path__ + "static/media/AngelBanner.98afa00d.svg";